module.exports = __webpack_public_path__ + "static/img/7_female.b67f9e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/character/7_female.png
// module id = bkHw
// module chunks = 0